const PropertyInsights = ({ insights = [] }) => {
  if (!insights.length) {
    return null;
  }

  return (
    <section className="property-detail-section" aria-label="Property insights">
      <h2 className="property-detail-section__title">Insights</h2>
      <div className="property-detail-insights">
        {insights.map((insight) => (
          <article
            key={insight.key}
            className={`property-detail-insight property-detail-insight--${insight.tone || "neutral"}`}
          >
            <p className="property-detail-insight__label">{insight.label}</p>
            <p className="property-detail-insight__value">{insight.value}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default PropertyInsights;
